import _ from 'lodash';

// TODO : À décommissioner.

const normalizeCriteria = criteria => {
  criteria = _.cloneDeep(criteria || {});

  if (_.isArray(criteria)) {
    criteria = { $or: criteria };
  }

  if (criteria.$and) {
    return criteria;
  }

  return {
    $and: _.chain(criteria)
      .keys()
      .map(key => ({ [key]: criteria[key] }))
      .value()
  };
};

export default normalizeCriteria;
